export const course_map = [
    {
        category: "核心課程",
        depiction: "",
        inner_data: [
            {
                course_name: "物件導向程式設計實習",
                course_id: "00",
                credit: "2",
                course_info_ch:
                    "使學生熟悉，物件導向程式設計之環境、方法、及原則，內容含：\
                1. C++ 設計環境 2. 類別與物件實習 3. 建構者與解構者實習 \
                4. 繼承實習 5. 虛擬函式與多型實習 6. 運算子溢載實習 \
                7. 例外處理實習 8. 泛型程式設計實習 9. 標準模板程式庫實習 10. 期末專題設計",
                course_info_en:
                    "This lab covers the following topics: introduction \
                to C complier used for ARM CPU, Debugger tools for ARM \
                CPU, functions of the evaluation board, usage of the \
                emulator, writing and debugging C language for ARM CPU, \
                writing and debugging assembly language of ARM, \
                combining C and asm codes, issues of using interrupts, \
                usage of various I/O devices, including parallel ports, \
                serial ports, A/D converters, and D/A converters, and \
                term project.",
                os: "",
                structure: "",
                web_program: "1",
                open_source: "1",
                team: "1",
                course_depiction: "",
                note: "",
                course_time: [
                    {
                        semester: "111學年第二學期",
                        id: "312799",
                        day: "週五",
                        time: "09:00~12:00"
                    },
                ],
                department: "資訊工程系",
                lecturer: "陳碩漢教授",
                material: [
                    {
                        title: "",
                        data_link: ""
                    },
                ]
            },
            {
                course_name: "軟體工程",
                course_id: "01",
                credit: "3",
                course_info_ch:
                    "本課程旨在介紹學生軟體工程的概念與技術，學生將學習開發高品質軟體相關的原理\
                    、觀念、方法、與技術，本課程將介紹下列主題：軟體工程簡介、軟體流程模型 、\
                    需求工程、軟體設計方法、軟體開發實務、軟體測試、軟體維護、軟體專案管理與規劃、\
                    軟體工程進階主題。",

                course_info_en:
                    "This course aims to provide students with a better knowledge \
                    and skills in software engineering. In particular, students will \
                    learn about the principles, concepts, methods, and techniques of \
                    the software engineering approach to producing quality software. \
                    The course covers the subjects on software process models, \
                    project management and planning, software requirement \
                    specifications and analysis models, software design methods, \
                    software verification and validation techniques, and software maintenance.",
                os: "",
                structure: "",
                web_program: "1",
                open_source: "1",
                team: "1",
                course_depiction: "",
                note: "",
                course_time: [
                    {
                        semester: "112學年第一學期",
                        id: "318914",
                        day: "週二",
                        time: "10:00~12:00"
                    }
                ],
                department: "資訊工程系",
                lecturer: "劉建宏教授",
                material: [
                    {
                        title: "Introduction to Scrum.pdf",
                        data_link: "/data/01_material/Introduction_to_Scrum.pdf"
                    }
                ]
            },
            {
                course_name: "網路程式設計",
                course_id: "02",
                credit: "3",
                course_info_ch:
                    "本課程探討各種計算機網路的應用程式介面，以及網路應用系統與核心系統軟體的設計\
                    與撰寫方式，並透過課程專題製作，實作各種網路應用系統軟體。其內容包含1. TCP/IP \
                    protocol, 2. Client Server Model and Software Design, 3. Concurrent \
                    Processing in Client-Server Software, 4. Socket API, 5. Client Software \
                    Design, 6. Server Software Design, 7. TCP and UDP, 8. Distributed \
                    Program Generation, 9. Inter-Process Communication.",

                course_info_en:
                    "This course discusses the application programming interfaces for \
                    computer networks. In addition, the design and programming methodology \
                    of network application systems are studied. Students will be required \
                    to complete a term programming project that implements network \
                    application systems. Course Contents: 1. TCP/IP, 2. Client Server \
                    Model and Software Design, 3. Concurrent Processing in Client-Server \
                    Software, 4. Socket API, 5. Client Software Design, 6. Server Software \
                    Design, 7. TCP and UDP, 8. RPC and Distributed Program Generation, \
                    9. NFS, and 10. Streaming Audio and Video Transport.",
                os: "",
                structure: "",
                web_program: "",
                open_source: "1",
                team: "1",
                course_depiction: "",
                note: "",
                course_time: [
                    {
                        semester: "112學年第一學期",
                        id: "323350",
                        day: "週三",
                        time: "13:00~16:00"
                    }
                ],
                department: "資訊工程系",
                lecturer: "郭忠義教授",
                material: [
                    {
                        title: "Linux Network Kernel Inter-process Communication Module.pdf",
                        data_link: "/data/02_material/Linux_Network_Kernel_Interprocess_Communication_Module.pdf"
                    }
                ]
            },
        ]
    },
    {
        category: "進階課程",
        depiction: "",
        inner_data: [
            {
                course_name: "作業系統",
                course_id: "04",
                credit: "3",
                course_info_ch:
                    "本課程旨在介紹學生軟體工程的概念與技術，學生將學習開發高品質軟體相關的原理\
                    、觀念、方法、與技術，本課程將介紹下列主題：軟體工程簡介、軟體流程模型 、\
                    需求工程、軟體設計方法、軟體開發實務、軟體測試、軟體維護、軟體專案管理與規劃、\
                    軟體工程進階主題。",

                course_info_en:
                    "This course is an introduction to the concepts, design, and \
                    implementation of operating systems software, as well as the \
                    relationship between operating system and hardware architecture. \
                    The major topics covered in this course are : 1. The evolution of \
                    operating systems 2.Processes and Threads 3.The features of concurrent \
                    processes 4.Process synchronization 5.Virtual memory 6.Distributed \
                    systems 7.Distributed concurrency control 8.File organization and \
                    management 9.Disk management and data access 10.Job scheduling \
                    11.System and network security",

                os: "1",
                structure: "",
                web_program: "1",
                open_source: "1",
                team: "1",
                course_depiction: "",
                course_time: [
                    {
                        semester: "111學年第二學期",
                        id: "312269",
                        day: "週一",
                        time: "13:00~15:00"
                    },
                    {
                        semester: "111學年第二學期",
                        id: "312269",
                        day: "週四",
                        time: "09:00~10:00"
                    }
                ],
                department: "資訊工程系",
                lecturer: "王正豪教授",
                material: [
                    {
                        title: "OpenSourceOS 00.pdf",
                        data_link: "/data/04_material/OpenSourceOS00.pdf"
                    },
                    {
                        title: "OpenSourceOS 01 Part I.pdf",
                        data_link: "/data/04_material/OpenSourceOS01PartI.pdf"
                    },
                    {
                        title: "OpenSourceOS 01 Part II.pdf",
                        data_link: "/data/04_material/OpenSourceOS01PartII.pdf"
                    },
                    {
                        title: "OpenSourceOS 02.pdf",
                        data_link: "/data/04_material/OpenSourceOS02.pdf"
                    },
                    {
                        title: "OpenSourceOS 03.pdf",
                        data_link: "/data/04_material/OpenSourceOS03.pdf"
                    },
                    {
                        title: "Exercise 01.pdf",
                        data_link: "/data/04_material/Exercise01.pdf"
                    },
                    {
                        title: "Programming Homewprk 01.pdf",
                        data_link: "/data/04_material/Programming Homewprk01.pdf"
                    },
                    {
                        title: "Programming Homewprk 02.pdf",
                        data_link: "/data/04_material/Programming Homewprk02.pdf"
                    },
                    {
                        title: "Programming Homewprk 03.pdf",
                        data_link: "/data/04_material/Programming Homewprk03.pdf"
                    },
                    {
                        title: "Programming Homewprk 04.pdf",
                        data_link: "/data/04_material/Programming Homewprk04.pdf"
                    },
                ]
            },
            {
                course_name: "嵌入式系統",
                course_id: "05",
                credit: "3",
                course_info_ch:
                    "本課程將詳細介紹嵌入式系統的工作原理和設計理念，主要重點是(1) Linux內核，\
                    (2) 網路物理系統，(3) 記憶體結構。請注意，在學習本課程之前，需要具備作業系統、\
                    C語言和使用基本Linux命令的知識。此外，本課程將以英語授課，請將本課程視為完善英語技能的好機會。",

                course_info_en:
                    "This course covers the following topics: introduction to ARM CPU, \
                    instruction set of ARM CPU, C complier of ARM CPU, debugging tools \
                    for ARM CPU, functions of the evaluation board, usage of emulator, \
                    writing and running C language in the evaluation board, introduction \
                    to Linux kernel, porting Linux kernel to the evaluation board, \
                    writing and installing the Linux device drivers, examples of \
                    applications, and term project.",
                os: "1",
                structure: "1",
                web_program: "",
                open_source: "1",
                team: "1",
                course_depiction: "",
                note: "",
                course_time: [
                    {
                        semester: "112學年第一學期",
                        id: "323382",
                        day: "週一 ",
                        time: "16:00~18:00"
                    },
                    {
                        semester: "112學年第一學期",
                        id: "323382",
                        day: "週三 ",
                        time: "09:00~10:00"
                    }
                ],
                department: "資訊工程系",
                lecturer: "張世豪教授",
                material: [
                    {
                        title: "Linux Kernel Module.pdf",
                        data_link: "/data/05_material/Linux_Kernel_Module.pdf"
                    },
                    {
                        title: "Linux Driver & Driver Framework.pdf",
                        data_link: "/data/05_material/Linux_Driver_Driver_Framework.pdf"
                    }

                ]
            },
        ]
    },
    {
        category: "總整課程",
        depiction: "",
        inner_data: [
            {
                course_name: "系統與軟韌體實務",
                course_id: "06",
                credit: "3",
                course_info_ch:
                    "本課程將基於核心與進階課程進行開展，導入Linux 與 QMEU開源專案以進行系統軟體\
                    與軟韌體開法，本課程著重之系統軟體包含Linux中驅動程式(Driver)機制、記憶體(Memory)資源管理、\
                    程序(Process)排程機制、檔案系統(File System)機制等。並以QMEU作為硬體模擬與韌體開發之平台。",

                course_info_en: "",
                os: "1",
                structure: "1",
                web_program: "",
                open_source: "1",
                team: "1",
                course_depiction: "",
                note: "",
                course_time: [
                    {
                        semester: "112學年第二學期",
                        id: "",
                        day: "",
                        time: ""
                    }
                ],
                department: "資訊工程系",
                lecturer: "劉傳銘教授",
                material: [
                    {
                        title: "",
                        data_link: ""
                    }
                ]
            },
        ]
    }
]